module.exports = __webpack_public_path__ + "static/witch_4k-842516ca2018e593d08743790f630f3d.jpg";